import type { ValueOf } from '@shared/types/utils';

export const NavigationItems = {
  hotel: 'hotel',
  traveller: 'traveller',
};

export type NavigationItemType = ValueOf<typeof NavigationItems>;
